import colors from '@theme/colors';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  customReasons: { flex: 1, marginBottom: 14, marginHorizontal: 16, marginTop: 16 },
  inputStyles: { borderColor: colors.neutral.darkMist, borderRadius: 12, borderWidth: 1, paddingHorizontal: 12 },
});
export default styles;
